<script setup>
import { onBeforeUnmount, onBeforeMount,ref } from "vue";
import { useRouter  } from "vue-router";
import { useStore } from "vuex";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Toast from 'primevue/toast';
const body = document.getElementsByTagName("body")[0];
import { useToast } from "primevue/usetoast";

const store = useStore();
const router = useRouter();
const toast = useToast();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  localStorage.clear();
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const user = ref('');
const password = ref('');

const handleLogin = async() => {
  const dataLogin = {
    user: user.value,
    password: password.value    
  }
  await store.dispatch('auth/login',dataLogin);
  if (store.state.auth.isLogunned) {
    store.state.auth.profile == 3 ? router.push({ name: 'Invoicings' }) : router.push({ name: 'Dashboard' })
  }else{
    toast.add({ severity: 'error', summary: 'Error', detail: 'Datos Ingresados Incorrectos', life: 4000 });
  }
}
</script>
<template>

  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <Toast />
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-6 col-md-6 d-flex flex-column mx-lg-8 mx-xl-5">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Login</h4>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <argon-input
                      id="user"
                      type="text"
                      placeholder="Usuario"
                      name="user"
                      v-model="user"
                      size="lg"
                    />
                  </div>
                  <div class="mb-3">
                    <argon-input
                      id="password"
                      type="password"
                      placeholder="Contraseña"
                      name="password"
                      v-model="password"
                      size="lg"
                    />
                  </div>
                  <div class="text-center">
                    <argon-button
                      class="mt-4"
                      variant="gradient"
                      color="danger"
                      fullWidth
                      size="lg"
                      @click="handleLogin">
                      Iniciar Sesión
                    </argon-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="top-0 my-auto text-center col-md-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div class="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden">
                <img src="../assets/img/Login/Banner2.jpeg" alt="">  
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
